module.exports = __webpack_public_path__ + "img/campingbanner.495e1482.jpg";